import { ContentBox } from '~/modules/settings/components/ContentBox';

import { useUserDetail } from '../../hooks/useUserDetail';
import { UserLabelGroups } from '../UserLabelGroups';
import { UserLabels } from '../UserLabels';

export function UserResources() {
  const { isInternal } = useUserDetail();

  return (
    <ContentBox>{isInternal ? <UserLabelGroups /> : <UserLabels />}</ContentBox>
  );
}
UserResources.displayName = 'UserResources';
